export function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)')
    return b ? b.pop() : ''
}

export function setCookie(cookieName, cookieValue, expireMin) {
    var myDate = new Date(new Date().getTime() + expireMin * 60000) // plus 60 minutes of duration of the cognito id
    console.log('write cookie ' + cookieName + '=' + cookieValue)
    document.cookie = cookieName + '=' + cookieValue + ';expires=' + myDate + ';domain=.audiencerate.com;path=/'
    
    // write also for localhost cookies when developing
    if(window.location.hostname === "localhost"){
        console.log('write cookie localhost ' + document.cookie)
        document.cookie = cookieName + '=' + cookieValue + ';expires=' + myDate + ';path=/'
        console.log('write cookie localhost2 ' + document.cookie)
    }
}

export function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = name + '=;domain=.audiencerate.com;path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}
